import { Slide } from './slide.model';

export class HomeSlider {
  _id: string;
  slides: Array<Slide> = [];
  active: boolean = false;
  created: Date;
  updated: Date;
};



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/home-slider/shared/home-slider.model.ts